import React from "react";
import DemoBadge from "./DemoBadge";

export const PageHeader = ({ eyebrow, title, subtitle, demo = false, actions = null }) => (
  <section className="relative overflow-hidden border-b border-gold-dim/25">
    <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-6 py-16 md:py-20">
      <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] uppercase text-gold mb-4">
        <span className="inline-block w-8 h-px bg-gold" /> {eyebrow}
        {demo && <DemoBadge />}
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
        {title}
      </h1>
      {subtitle && <p className="mt-5 max-w-3xl text-base md:text-lg text-cream-dim leading-relaxed">{subtitle}</p>}
      {actions && <div className="mt-8 flex flex-wrap gap-3">{actions}</div>}
    </div>
  </section>
);

export default PageHeader;
